import {useEffect} from "react";
import {Notifier} from "@advthreat/ribbon-components";
import {useDispatch, useSelector} from "react-redux";
import {clearNotification} from "store/features/notificationsSlice";
import {selectNotificationNote} from "store/selectors";

const ToastNotification = () => {
  const dispatch = useDispatch();
  const notification = useSelector(selectNotificationNote);

  useEffect(() => {
    if (
      notification &&
      notification.title &&
      notification.text &&
      notification.theme
    ) {
      dispatch(clearNotification());
      Notifier.addNotification({
        icon: "ats-components-cisco-logo",
        title: notification.title,
        text: notification.text,
        theme: notification.theme
      });
    }
  }, [notification, dispatch]);

  return null;
};

export default ToastNotification;
